import { Component, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-mech-engine",
	templateUrl: "./mech-engine.component.html",
	styleUrls: ["./mech-engine.component.scss"],
	imports: [FormsModule]
})
export class MechEngineComponent {
	private api = inject(ApiService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	async UpdateAltEngine() {
		await this.api.UpdateAltEngine(this.asset.asset_id, this.asset.alt_engine);
	}

}
